import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/territory`;

/**
 * GET
 */

export const getTerritoryOptions = async (states = [], cities = [], counties = [], zipCodes = []) => {
  const url = `${baseRoute}/options?`;
  let headers = getHeaders();

  const body = {
    states: states,
    cities: cities,
    counties: counties,
    zipCodes: zipCodes,
  };

  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getZipCodeDetails = async zipCode => {
  const q = queryString.stringify({ zipCode });

  const url = `${baseRoute}/zipcode-details?${q}`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  
  return response.ok ? await response.json() : Promise.reject(null);
};

export const getAssignedTerritoryInfo = async (inspectorId = null, fieldManagerId = null) => {
  let url = `${baseRoute}/assigned?`;
  let headers = getHeaders();

  if (inspectorId !== null) {
    url += `inspectorId=${inspectorId}`;
  }
  if (fieldManagerId !== null) {
    url += `fieldManagerId=${fieldManagerId}`;
  }

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(response);
};

/**
 * PUT
 */

export const updateTerritoryInfo = async territoryInfo => {
  let url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(territoryInfo),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
